import styled from 'styled-components';

export const CardTag = styled.article`
  position: relative;
  
  height: 100%;
  padding: 20px 25px;
  padding-top: 35px;
  
  color: ${({ theme }) => theme.black};
  
  border-radius: 6px;
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  
  @media(min-width: 700px) {
    padding: 20px 40px;
    padding-top: 50px;
    padding-right: 60px;
  }
  
  @media(min-width: 1024px) {
    padding-top: 40px;
  }
`;

export const CardArrow = styled.span`
  position: absolute;
  bottom: 0;
  right: 0;
  
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 50px;
  height: 50px;
  padding-bottom: 15px;
  padding-right: 15px;
  
  font-size: 0;
  
  background: transparent linear-gradient(135deg, #2DB9FE 0%, #4EDBFC 100%) no-repeat center;
  box-shadow: 0 0 20px rgba(30, 182, 255, 0.24);
  border-radius: 100px 0 6px 0;
  
  svg {
    transform: rotate(-90deg);
  }
`;

export const CardHeading = styled.h3`
  margin: 0;
  padding: 0;
  
  font-size: 30px;
  line-height: 35px;
  
  @media(min-width: 700px) {
    margin-bottom: 10px;
    
    font-size: 36px;
    line-height: 45px;
  }
`;

export const CardDescription = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 16px;
  line-height: 22px;
`;
